module.exports = __webpack_public_path__ + "static/WhenThePastWasAround2-cf5e665142eb15bb752687dbb84a6cf2.webp";